export const PROVIDER = {
  legalName: 'HARPIA BR - RECUPERACAO DE ATIVOS LTDA',
  cnpj: '55.520.395/0001-45',
} as const;
